import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DbService } from '../services/db.service';

export const homeGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const dbService = inject(DbService);

  const shipmentId = route.queryParamMap.get('shipmentId');
  if (shipmentId) {
    return true;
  }

  try {
    const shipments = await dbService.getShipments();

    if (shipments && shipments.length > 0) {
      router.navigate(['/shipment']);
      return false;
    }
  } catch (error) {
    console.error('Error checking shipments:', error);
  }

  return true;
};
